import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from './logger';
import normalizePath from './normalizePath';
import { setGlobalContext } from './context';

/**
 * Tracks a page view per route change, named by normalised path so that
 * /company/48213 and /company/48214 group together.
 *
 * Replaces the SDK's enableAutoRouteTracking, which hooks history.pushState globally and
 * names page views by raw URL. Also records the current route in the ambient context so every
 * later log event says which page the user was on.
 *
 * Must be called unconditionally (React hook rules), from a component inside the router.
 */
export default function usePageViews() {
  const location = useLocation();
  const path = normalizePath(location.pathname);

  useEffect(() => {
    setGlobalContext({ Route: path });
    // Deliberately not location.search: the search route carries user search terms.
    logger.pageView(path, path);
  }, [path]);
}
